import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import cond from 'lodash/cond';

import {
    setSessionsStepsLabel,
    setSessionsStepsBackButtonLabel,
    setSessionsStepsNextButtonLabel,
    setSessionsStepsSubmitButtonLabel,
    getFormSessionStepsLabel,
    getFormSessionStepsBackButtonLabel,
    getFormSessionStepsNextButtonLabel,
    getFormSessionStepsSubmitButtonLabel,
} from 'common/entities/form/sessionRegistration';

import { resetEditingFormNode } from '../../actions';
import { getActiveFormEditView, getFormId } from '../../selectors';

import EditViewHeader from './EditViewHeader';

import EditViewSectionContainer from './EditViewSectionContainer';
import DraftTextEditorWrapper from './components/DraftTextEditorWrapper';
import EditSessionsRegistration from './EditSessionsRegistration';

const titles = {
    label: 'Headline',
    backButton: 'Back Button',
    nextButton: 'Next Button',
    submitButton: 'Submit Button',
    settings: 'Sessions Registration',
};

const EditTextContent = (props) => (
    <EditViewSectionContainer>
        <DraftTextEditorWrapper
            fullWidth
            label={props.label}
            value={props.value}
            placeholder={props.placeholder}
            onChangeLabel={props.onChangeLabel}
        />
    </EditViewSectionContainer>
);

EditTextContent.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    onChangeLabel: PropTypes.func.isRequired,
};

export function EditFormSessionsPanel(props) {
    const reduxDispatch = useDispatch();

    const formId = useSelector(getFormId);
    const activeFormEditView = useSelector(getActiveFormEditView);
    const headline = useSelector((state) => getFormSessionStepsLabel(state, formId));
    const backButtonLabel = useSelector((state) => getFormSessionStepsBackButtonLabel(state, formId));
    const nextButtonLabel = useSelector((state) => getFormSessionStepsNextButtonLabel(state, formId));
    const submitButtonLabel = useSelector((state) => getFormSessionStepsSubmitButtonLabel(state, formId));

    return (
        <div>
            <EditViewHeader
                label={titles[activeFormEditView.setting]}
                saveEditFormNode={() => reduxDispatch(resetEditingFormNode())}
            />
            {cond([
                [
                    () => activeFormEditView.setting === 'label',
                    () => (
                        <EditTextContent
                            label="Headline text"
                            placeholder="Add your headline text..."
                            value={headline}
                            onChangeLabel={(event, label, labelMarkup) =>
                                reduxDispatch(setSessionsStepsLabel(formId, labelMarkup))
                            }
                        />
                    ),
                ],
                [
                    () => activeFormEditView.setting === 'backButton',
                    () => (
                        <EditTextContent
                            label="Back button text"
                            placeholder="Add your back button text..."
                            value={backButtonLabel}
                            onChangeLabel={(event, label, labelMarkup) =>
                                reduxDispatch(setSessionsStepsBackButtonLabel(formId, labelMarkup))
                            }
                        />
                    ),
                ],
                [
                    () => activeFormEditView.setting === 'nextButton',
                    () => (
                        <EditTextContent
                            label="Next button text"
                            placeholder="Add your next button text..."
                            value={nextButtonLabel}
                            onChangeLabel={(event, label, labelMarkup) =>
                                reduxDispatch(setSessionsStepsNextButtonLabel(formId, labelMarkup))
                            }
                        />
                    ),
                ],
                [
                    () => activeFormEditView.setting === 'submitButton',
                    () => (
                        <EditTextContent
                            label="Submit button text"
                            placeholder="Add your submit button text..."
                            value={submitButtonLabel}
                            onChangeLabel={(event, label, labelMarkup) =>
                                reduxDispatch(setSessionsStepsSubmitButtonLabel(formId, labelMarkup))
                            }
                        />
                    ),
                ],
                [() => activeFormEditView.setting === 'settings', () => <EditSessionsRegistration />],
            ])()}
        </div>
    );
}
